function removeVideoOverlay(documentRef, overlayId) {
  const overlay = documentRef.getElementById(overlayId)
  if (!overlay) return
  const video = overlay.querySelector('video')
  if (video) video.pause()
  overlay.remove()
}

function attachClipLoop(video, event, getVideoClipRangeFromEvent, clipPadding) {
  const videoRange = getVideoClipRangeFromEvent(event, clipPadding)
  video.addEventListener('loadedmetadata', function() {
    const end = Math.min(videoRange.end, video.duration)
    video.currentTime = videoRange.start
    video._clipStart = videoRange.start
    video._clipEnd = end
    const playPromise = video.play()
    if (playPromise !== undefined) {
      playPromise.catch(error => {
        console.warn('Autoplay play() failed:', error)
      })
    }
  })
  video.addEventListener('timeupdate', function() {
    if (
      video.currentTime < video._clipStart ||
      video.currentTime >= video._clipEnd
    ) {
      video.currentTime = video._clipStart
      video.play()
    }
  })
}

export function showVideoEventModal({
  documentRef,
  videoPath,
  event,
  getVideoClipRangeFromEvent,
  overlayId,
  videoId,
  clipPadding = 5,
}) {
  removeVideoOverlay(documentRef, overlayId)

  const overlay = documentRef.createElement('div')
  overlay.setAttribute('id', overlayId)
  overlay.style.position = 'fixed'
  overlay.style.left = '0'
  overlay.style.top = '0'
  overlay.style.width = '100vw'
  overlay.style.height = '100vh'
  overlay.style.background = 'rgba(80,80,80,0.7)'
  overlay.style.zIndex = 2000
  overlay.style.display = 'flex'
  overlay.style.alignItems = 'center'
  overlay.style.justifyContent = 'center'

  const modal = documentRef.createElement('div')
  modal.style.position = 'relative'
  modal.style.background = 'rgba(255,255,255,0.95)'
  modal.style.borderRadius = '16px'
  modal.style.boxShadow = '0 4px 32px rgba(0,0,0,0.2)'
  modal.style.padding = '0'
  modal.style.display = 'flex'
  modal.style.flexDirection = 'column'
  modal.style.alignItems = 'center'
  modal.style.justifyContent = 'center'
  modal.style.width = '90vw'
  modal.style.height = '80vh'
  modal.style.maxWidth = '90vw'
  modal.style.maxHeight = '80vh'
  modal.style.minWidth = '320px'
  modal.style.minHeight = '180px'

  const closeBtn = documentRef.createElement('button')
  closeBtn.innerHTML = '&times;'
  closeBtn.style.position = 'absolute'
  closeBtn.style.top = '12px'
  closeBtn.style.right = '18px'
  closeBtn.style.fontSize = '2.2rem'
  closeBtn.style.background = 'transparent'
  closeBtn.style.border = 'none'
  closeBtn.style.cursor = 'pointer'
  closeBtn.style.color = '#333'
  closeBtn.style.zIndex = 10
  closeBtn.setAttribute('aria-label', 'Close')
  closeBtn.addEventListener('click', function() {
    removeVideoOverlay(documentRef, overlayId)
  })

  const video = documentRef.createElement('video')
  video.src = videoPath
  video.controls = true
  video.autoplay = true
  video.loop = true
  video.muted = true
  video.setAttribute('id', videoId)
  video.style.pointerEvents = 'auto'
  video.style.background = 'black'
  video.style.borderRadius = '12px'
  video.style.width = '100%'
  video.style.height = '100%'
  video.style.margin = '0'
  video.style.objectFit = 'contain'
  attachClipLoop(video, event, getVideoClipRangeFromEvent, clipPadding)

  overlay.addEventListener('mousedown', function(mouseEvent) {
    if (mouseEvent.target === overlay)
      removeVideoOverlay(documentRef, overlayId)
  })
  modal.appendChild(closeBtn)
  modal.appendChild(video)
  overlay.appendChild(modal)
  documentRef.body.appendChild(overlay)
}
